import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { take } from "rxjs/operators";
import { CustomerCategoryFormComponent } from "./customer-category-form.component";
@Component({
  selector: "ngx-customer-categories-list",
  template: `<div class="page" style="height:100%; padding:1rem; background: var(--bg-primary);">
    <kgrid
      [apiName]="apiName"
      [noAutoFitColumns]="true"
      [label]="label"
      [areaName]="areaName"
      [name]="apiName"
      defaultSortKey="Code"
      reportName="CustomerCategory"
      pathPreFix="SALE"
      [isMulti]="true"
      [IgnoreDeletePermission]="IgnoreDelete"
      [deleteMessage]="deleteMessage"
      [inputEditorform]="inputEditorform"
      [isAdd]="isAdd"
      [isEdit]="isEdit"
      [isDelete]="isDelete">
    </kgrid>
  </div>`,
})
export class CustomerCategoryListComponent extends BaseListComponent {
  IgnoreDelete: boolean = false;
  deleteMessage: string = "";
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  constructor() {
    super();
    this.inputEditorform = CustomerCategoryFormComponent;
    this.FillData();
  }

  ngOnInit() {
    this.apiName = "CustomerCategory";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.CustomerCategory");
  }

  async FillData() {
    const info = this.accountService.authService.currentInformation();
    if (info.RestaurantCallCenter) {
      if (!this.accountService.authService.currentBranch.AccessToAllBranches) {
        this.isAdd = false;
        this.isEdit = false;
        this.isDelete = false;
      }
    }
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      const hasBranchCommunication = JSON.parse(localStorage.getItem("HasBranchCommunication"));
      if (hasBranchCommunication == null) {
        this.httpCommonService
          .getList(`Branch/HasBranchCommunication/${this.accountService.authService.currentBranchId}`)
          .pipe(take(1))
          .subscribe(async (hbc: boolean) => {
            if (hbc === true) {
              this.IgnoreDelete = true;
              this.deleteMessage = this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.HasBranchCommunication");
            }
          });
      } else if (hasBranchCommunication) {
        this.IgnoreDelete = true;
        this.deleteMessage = this.translate("ClientApp.FrontOffice.Parties.CustomerCategory.HasBranchCommunication");
      }
    }
  }
}
